const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  create ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/refund/create', params, {
      baseURL: 'https://apisp.jyb.com.tw',
    })
  },
  uploadRefundVoucher ({ state, commit, rootState }, params) {
    return rootState.axios.post('/magicbuy/ali-dg/trade/refund/upload-refund-voucher', params, {
      baseURL: 'https://apisp.jyb.com.tw',
      headers: { 'Content-Type': 'multipart/form-data' },
    })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
